var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPuzzleBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 803 550"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_blue_svg__a",
    x1: 316.45,
    y1: 448.65,
    x2: 380.42,
    y2: 448.65,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a6ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c57ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_blue_svg__b",
    x1: 181.01,
    y1: 290.61,
    x2: 265.07,
    y2: 290.61,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2c4bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a65f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_blue_svg__c",
    x1: 192214,
    y1: 295.15,
    x2: 201610,
    y2: 295.15,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c57ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c57ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.56 224.91L390 174.4v-23l-37.07 1.6-34.52-20a2 2 0 01-.57-3.46 7.76 7.76 0 015.61-1.91c14.56.45 29.34-3 40.55-9.46 10.41-6 15.95-13.67 16.4-21a15.37 15.37 0 000-1.92v-23l-12.64 6.55c-17.37-9.31-46.71-7.91-66.18 3.34-11.19 6.47-17.17 15-16.39 23.44.12 1.28-1.21 2.58-3.31 3.24a7.92 7.92 0 01-6-.35L209 69.84l-166.21 96L0 167.61v23l181 104.52 81-46.78a8.77 8.77 0 016-.83v12.57c.12 6.37 4.12 12.31 11.59 16.63 17.2 9.94 47.38 8.69 67.25-2.8 10.67-6.17 16.23-14.05 16.43-21.57v-26.07l-28.53 3.11a80.75 80.75 0 00-27.77.43c-2.35.44-4.7 0-5.74-1.2s-.48-2.62 1.33-3.71z",
    fill: "#4a6ff4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.45 76v54.42h.85a2.91 2.91 0 01.53-.78 7.76 7.76 0 015.61-1.91c14.56.45 29.34-3 40.55-9.47 10.41-6 15.95-13.66 16.4-21a15.38 15.38 0 000-1.92v-23l-12.64 6.49C354.4 71.65 334 70.84 316.45 76z",
    fill: "url(#puzzle_blue_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.3 205.63l1.54 23.09 4.23-2.47a4.17 4.17 0 011.49-1.34L390 174.39v-22.95z",
    fill: "#2c57ef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.74 247.44l.31-23.79L181 272.16v23l81-46.78a7.93 7.93 0 012.74-.94z",
    fill: "url(#puzzle_blue_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307 229.82c-.33.06-.67.1-1 .13v53.41c14 .49 29.22-2.69 40.88-9.43 10.67-6.16 16.23-14 16.43-21.56V226.3l-28.53 3.09a80.76 80.76 0 00-27.78.43z",
    fill: "url(#puzzle_blue_svg__c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181 272.16l81-46.78a8.75 8.75 0 016.42-.75c2 .59 2.84 2 2.07 3.3-5.37 9.57-1.88 19.47 9.13 25.82 17.21 9.94 47.38 8.7 67.25-2.79s22-28.91 4.83-38.85c-11-6.36-28.13-8.37-44.7-5.27-2.35.44-4.69-.05-5.73-1.19s-.5-2.67 1.31-3.72L390 151.42l-71.6-41.36a2 2 0 01-.57-3.46 7.74 7.74 0 015.61-1.91c14.56.45 29.34-3 40.55-9.47 19.87-11.48 22-28.9 4.83-38.85s-47.38-8.69-67.25 2.8c-11.19 6.47-17.17 15-16.39 23.42.12 1.28-1.22 2.58-3.31 3.24a8 8 0 01-6-.35L209 46.88 0 167.61z",
    fill: "#326bff"
  })));
}

export default SvgPuzzleBlue;